import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { 
  Star, 
  MapPin, 
  Phone, 
  Shield, 
  Clock,
  Luggage,
  Users,
  Home,
  Calendar,
  Coffee
} from 'lucide-react';
import { FiHome } from 'react-icons/fi';
import { MdHome } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';

// Import vehicle images
// import sedan from "../../assets/image.png";
// import ertiga from "../../assets/image.png";
import crysta from "../../assets/image.png";
import hycross from "../../assets/image.png";
import fortuner from "../../assets/image.png";
import tempo from "../../assets/image.png";

const sedan ="https://static.caronphone.com/public/brands/21/493/2518/2518_1731400393.webp"
const city=    "https://c4.wallpaperflare.com/wallpaper/614/644/854/2019-corolla-gli-toyota-wallpaper-thumb.jpg"
const ertiga ="https://imgd.aeplcdn.com/664x374/n/c6es93a_1572125.jpg?q=80"

const Y = "#28aa96";
const YD = "#020202";
const YL = "#FFF9E6";
const font = "'Nunito', sans-serif";

const LOCAL_VEHICLES = [
  { 
    id: 1, 
    image: "sedan", 
    name: "Swift Dzire", 
    models: "Swift Dzire", 
    type: "Economy", 
    seaters: "4", 
    bags: 2, 
    price: "₹1,300", // Add base price
    price8hr: "₹2,200",
    packages: {
      '4hr': { price: "₹1000", kms: 40, extraKm: "₹13", extraHr: "₹175" },
      '8hr': { price: "₹2000", kms: 80, extraKm: "₹13", extraHr: "₹175" }
    },
    tag: "Popular", 
    badge: "popular", 
    rating: 4.6, 
    features: ["AC", "Music", "Charger"]
  },
  { 
    id: 2, 
    image: "premiumSedan", 
    name: "Toyota Etios", 
    models: "Toyota Etios", 
    type: "Comfort", 
    seaters: "4", 
    bags: 2, 
    price: "₹1,400",
    price8hr: "₹2,300",
    packages: {
      '4hr': { price: "₹1,000", kms: 40, extraKm: "₹13", extraHr: "₹175" },
      '8hr': { price: "₹2,000", kms: 80, extraKm: "₹13", extraHr: "₹175" }
    },
    tag: "Value", 
    badge: "value", 
    rating: 4.6, 
    features: ["AC", "Music", "Charger", "Legroom"]
  },
  // { 
  //   id: 3, 
  //   image: "ertiga", 
  //   name: "Maruti Ertiga", 
  //   models: "Ertiga", 
  //   type: "Family", 
  //   seaters: "6", 
  //   bags: 4, 
  //   price: "₹2,100",
  //   price8hr: "₹2,900",
  //   packages: {
  //     '4hr': { price: "₹2,100", kms: 40, extraKm: "₹17", extraHr: "₹170" },
  //     '8hr': { price: "₹2,900", kms: 80, extraKm: "₹17", extraHr: "₹170" }
  //   },
  //   tag: "Family", 
  //   badge: "value", 
  //   rating: 4.5, 
  //   features: ["Family", "Extra Luggage", "3 Rows"]
  // },
//   { 
//     id: 4, 
//     image: "crysta", 
//     name: "Innova Crysta", 
//     models: "Toyota Innova Crysta", 
//     type: "Premium", 
//     seaters: "7", 
//     bags: 5, 
//     price: "₹3,500",
//     packages: {
//       '8hr': { price: "₹3,500", kms: 80, extraKm: "₹22", extraHr: "₹220" }
//     },
//     tag: "Premium", 
//     badge: "top", 
//     rating: 4.9, 
//     features: ["Luxury", "Captain Seats", "Premium AC"]
//   }
];

const BADGES = {
  popular: { bg: "#FFF3CD", color: "#92400E", label: "🔥 Popular" },
  value: { bg: "#D1FAE5", color: "#065F46", label: "💎 Best Value" },
  top: { bg: "#FEE2E2", color: "#991B1B", label: "⭐ Top Pick" },
};

const getVehicleImage = (vehicle) => {
  const map = { 
    sedan: sedan,
    premiumSedan: city,
    ertiga: ertiga,
    crysta: crysta,
    hycross: hycross,
    fortuner: fortuner,
    tempo: tempo,
    default: crysta 
  };
  return map[vehicle.image] || map.default;
};

function VehicleCard({ v, onBook, onWhatsApp, index }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState('4hr');
  const bc = v.badge ? BADGES[v.badge] : null;
  const imageUrl = getVehicleImage(v);
  
  // Check if vehicle has both packages or only 8hr
  const hasBothPackages = v.packages && v.packages['4hr'] && v.packages['8hr'];
  const hasOnly8hr = v.packages && !v.packages['4hr'] && v.packages['8hr'];
  
  // Set default package to '8hr' if only 8hr is available
  useEffect(() => {
    if (hasOnly8hr) {
      setSelectedPackage('8hr');
    }
  }, [hasOnly8hr]);
  
  // Get current package safely
  const currentPackage = v.packages && v.packages[selectedPackage] 
    ? v.packages[selectedPackage] 
    : { price: "₹0", kms: 0, extraKm: "₹0", extraHr: "₹0" };

  return (
    <div style={{
      background: "#fff",
      borderRadius: 24,
      overflow: "hidden",
      marginBottom: 16,
      boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
      border: "1.5px solid #F0F0F0",
      animation: `fadeIn 0.4s ${index * 0.06}s ease both`,
    }}>
      <div style={{ display: "flex", flexDirection: window.innerWidth <= 768 ? "column" : "row" }}>
        {/* Image Section */}
        <div style={{
          position: "relative",
          width: window.innerWidth <= 768 ? "100%" : "280px",
          height: window.innerWidth <= 768 ? "180px" : "200px",
          background: "#f8f8f8",
          overflow: "hidden",
        }}>
          {!imageLoaded && (
            <div style={{ 
              position: "absolute", 
              inset: 0, 
              background: "linear-gradient(90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%)", 
              backgroundSize: "200% 100%", 
              animation: "shimmer 1.5s infinite" 
            }} />
          )}
          <img 
            src={imageUrl} 
            alt={v.name} 
            onLoad={() => setImageLoaded(true)} 
            style={{ 
              width: "100%", 
              height: "100%", 
              objectFit: "contain", 
              opacity: imageLoaded ? 1 : 0 
            }} 
          />
          {bc && (
            <div style={{ 
              position: "absolute", 
              top: 12, 
              left: 12, 
              background: bc.bg, 
              borderRadius: 20, 
              padding: "4px 12px", 
              zIndex: 2 
            }}>
              <span style={{ fontSize: 11, fontWeight: 800, color: bc.color }}>{bc.label}</span>
            </div>
          )}
          <div style={{ 
            position: "absolute", 
            top: 12, 
            right: 12, 
            background: "rgba(255,255,255,0.95)", 
            borderRadius: 20, 
            padding: "4px 10px", 
            display: "flex", 
            alignItems: "center", 
            gap: 4 
          }}>
            <Home size={10} color={Y} />
            <span style={{ fontSize: 10, fontWeight: 700 }}>Local</span>
          </div>
        </div>

        {/* Content Section */}
        <div style={{ flex: 1, padding: "16px 20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
            <div>
              <h3 style={{ fontSize: 18, fontWeight: 900, color: "#1A1A1A", margin: "0 0 4px" }}>{v.name}</h3>
              <p style={{ fontSize: 12, color: "#666", margin: 0 }}>{v.models} • {v.seaters}+1 seats</p>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Star size={14} color={Y} fill={Y} />
              <span style={{ fontSize: 13, fontWeight: 700 }}>{v.rating}</span>
            </div>
          </div>

          {/* Package Selector - Only show if both packages available */}
          {hasBothPackages && (
            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
              <button 
                onClick={() => setSelectedPackage('4hr')} 
                style={{ 
                  flex: 1, 
                  border: "none", 
                  background: selectedPackage === '4hr' ? Y : "#F0F0F0", 
                  color: selectedPackage === '4hr' ? "#1A1A1A" : "#666", 
                  padding: "8px", 
                  borderRadius: 10, 
                  fontSize: 12, 
                  fontWeight: 700, 
                  cursor: "pointer" 
                }}
              >
                4 Hrs / 40 Kms
              </button>
              <button 
                onClick={() => setSelectedPackage('8hr')} 
                style={{ 
                  flex: 1, 
                  border: "none", 
                  background: selectedPackage === '8hr' ? Y : "#F0F0F0", 
                  color: selectedPackage === '8hr' ? "#1A1A1A" : "#666", 
                  padding: "8px", 
                  borderRadius: 10, 
                  fontSize: 12, 
                  fontWeight: 700, 
                  cursor: "pointer" 
                }}
              >
                8 Hrs / 80 Kms
              </button>
            </div>
          )}

          {/* Show indicator for 8hr only packages */}
          {hasOnly8hr && (
            <div style={{ 
              background: "#F0F0F0", 
              padding: "8px", 
              borderRadius: 10, 
              marginBottom: 12, 
              textAlign: "center",
              fontSize: 12,
              fontWeight: 700,
              color: "#666"
            }}>
              8 Hrs / 80 Kms Package Only
            </div>
          )}

          {/* Package Details */}
          <div style={{ background: "#F8F8F8", borderRadius: 16, padding: "12px 16px", marginBottom: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
              <span style={{ fontSize: 20, fontWeight: 900, color: "#1A1A1A" }}>{currentPackage.price}</span>
              <span style={{ fontSize: 12, color: "#666" }}>{currentPackage.kms} kms included</span>
            </div>
            <div style={{ display: "flex", gap: 16, fontSize: 12, color: "#666" }}>
              <span>Extra km: {currentPackage.extraKm}/km</span>
              <span>Extra hr: {currentPackage.extraHr}/hr</span>
            </div>
          </div>

          {/* Features */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 12 }}>
            {v.features && v.features.map((f, fi) => (
              <span key={fi} style={{ 
                fontSize: 10, 
                fontWeight: 600, 
                color: YD, 
                background: YL, 
                padding: "3px 10px", 
                borderRadius: 20 
              }}>
                {f}
              </span>
            ))}
          </div>

          {/* Action Buttons */}
          <div style={{ display: "flex", gap: 10 }}>
            <button 
              onClick={() => onBook({...v, selectedPackage, packageDetails: currentPackage})} 
              style={{ 
                flex: 1, 
                background: Y, 
                border: "none", 
                color: "#1A1A1A", 
                padding: "12px 0", 
                borderRadius: 12, 
                fontSize: 14, 
                fontWeight: 800, 
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
            >
              Book Now
            </button>
            <button 
              onClick={() => onWhatsApp(v)} 
              style={{ 
                width: 44, 
                height: 44, 
                background: "#25D366", 
                border: "none", 
                color: "#fff", 
                borderRadius: 12, 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
            >
              <FaWhatsapp size={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function LocalPackages() {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleBookNow = (vehicle) => {
    navigate('/booking', { 
      state: { 
        vehicle: vehicle,
        tripType: 'Local Taxi'
      } 
    });
  };

  const handleWhatsApp = (vehicle) => {
    const phoneNumber = "919150410309";
    const message = `Hello! I'm interested in booking ${vehicle.name} for local package.`;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const packages = [
    { hours: 4, kms: 40, price: "₹1,000", desc: "Shopping, Meetings" },
    { hours: 8, kms: 80, price: "₹2,000", desc: "Temples, Sightseeing" },
    { hours: 12, kms: 120, price: "₹3,000", desc: "Full Day Tour" },
  ];

  return (
    <div style={{ 
      minHeight: "100vh", 
      background: "#F5F5F5", 
      fontFamily: font, 
      padding: isMobile ? "20px 16px 60px" : "40px 20px" 
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap');
        *{box-sizing:border-box;}
        @keyframes fadeIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
        @keyframes shimmer{0%{background-position:-200% 0}100%{background-position:200% 0}}
      `}</style>

      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        {/* Header */}
        <div style={{ marginBottom: 30 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
            <div style={{ background: Y, borderRadius: 12, padding: 8 }}>
              <FiHome size={24} color="#1A1A1A" />
            </div>
            <h1 style={{ fontSize: isMobile ? 28 : 36, fontWeight: 900, color: "#1A1A1A", margin: 0 }}>
              Local <span style={{ color: Y }}>Packages</span>
            </h1>
          </div>
          <p style={{ fontSize: 14, color: "#666", maxWidth: 500 }}>
            Hourly rental packages for city travel, shopping, and sightseeing
          </p>
        </div>

        {/* Package Info */}
        <div style={{ 
          display: "grid", 
          gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", 
          gap: 16, 
          marginBottom: 30 
        }}>
          {packages.map((pkg, i) => (
            <div key={i} style={{ 
              background: "#fff", 
              borderRadius: 16, 
              padding: 20, 
              border: "1px solid #F0F0F0", 
              textAlign: "center" 
            }}>
              <Calendar size={24} color={Y} style={{ marginBottom: 8 }} />
              <div style={{ fontSize: 18, fontWeight: 800, color: "#1A1A1A" }}>{pkg.hours} Hours</div>
              <div style={{ fontSize: 14, color: "#666", marginBottom: 8 }}>{pkg.kms} Kms included</div>
              <div style={{ fontSize: 20, fontWeight: 900, color: Y, marginBottom: 4 }}>{pkg.price}</div>
              <div style={{ fontSize: 12, color: "#999" }}>{pkg.desc}</div>
            </div>
          ))}
        </div>

        {/* Vehicle List */}
        <div>
          {LOCAL_VEHICLES.map((vehicle, index) => (
            <VehicleCard
              key={vehicle.id}
              v={vehicle}
              index={index}
              onBook={handleBookNow}
              onWhatsApp={handleWhatsApp}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
